module.exports = __webpack_public_path__ + "images/road_sewer.bbc494058c868b59e35d805504c233f8.png";